import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { TableColumn } from '@mynexus/mynexus-ui-lib';

interface Service {
  serviceNumber: string;
  createdDate: string;
  requestReceivedDate: string;
  urgency: string;
  daysRequested: string;
  daysApproved: string;
  effectiveStartDate: string;
  effectiveEndDate: string;
  serviceStatus: string;
  decisionDate: string;
  urgencyChangeDate: string;
  extensionTakenDate: string;
  serviceStatusReason: string;
}

@Component({
    selector: 'app-services-shared',
    templateUrl: './services-shared.component.html',
    styleUrls: ['./services-shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ServicesSharedComponent {
  @Input() services!: Service[];
  @Output() selectedServices = new EventEmitter<any[]>();

  selected!: Service[];

  columns: TableColumn[] = [
    new TableColumn('Select', '', '28px'),
    new TableColumn('Service No.', 'serviceNumber', '40px'),
    new TableColumn('Date Time Created', 'createdDate', '300px'),
    new TableColumn('Date Time Request received', 'requestReceivedDate', '300px'),
    new TableColumn('Urgency', 'urgency', '140px'),
    new TableColumn('Requested Days', 'daysRequested', '140px'),
    new TableColumn('Approved Days', 'daysApproved', '140px'),
    new TableColumn('Effective From', 'effectiveStartDate', '180px'),
    new TableColumn('Effective Through', 'effectiveEndDate', '180px'),
    new TableColumn('Status', 'serviceStatus', '140px'),
    // The Decision column name was changed to Processed under CR-237303. The difference between column name and DTO property name IS intentional
    new TableColumn('Processed Date', 'decisionDate', '240px'),
    new TableColumn('Date Urgency Change Downgr.', 'urgencyChangeDate', '240px'),
    new TableColumn('Date Extension Taken', 'extensionTakenDate', '240px'),
    new TableColumn('Status Reason', 'serviceStatusReason', '300px'),
  ];

  onRowSelect() {
    this.selectedServices.emit(this.selected);
  }

  onRowUnselect() {
    this.selectedServices.emit(this.selected);
  }
}
